import { Skeleton } from 'ui/skeleton';
import { GridRow } from 'ui/indexPages/tables/grid';
import { JOBS_TABLE_COLUMNS } from 'modules/jobManager/types';
import { TABLE_GRID } from 'modules/jobManager/constants';

const skeletonColumnCount = Object.keys(JOBS_TABLE_COLUMNS).length + 1;

export const SkeletonRow = () => (
  <GridRow gridLayout={TABLE_GRID} data-test="jobs-index-table-loading">
    {[...Array(skeletonColumnCount)].map((_, i) => (
      <Skeleton key={i} height={50} shimmerSpeed={2500} />
    ))}
  </GridRow>
);
